import consumer from './consumer';

export default {
  subscribe(callback) {
    return consumer.subscriptions.create(
      { channel: 'TrackTimeImmediatelyChannel' },
      {
        connected() {
          callback();
        },
        received() {
          callback();
        },
      },
    );
  },
};
